import styled from 'styled-components';
import { plus } from './theme';

/**
 * Título das telas Rock Plus. Vai na prop `title` das rotas para ser renderizado
 * dentro do header do AppLayout — as páginas não repetem o título no corpo.
 */
const PageTitle = styled.span`
  font-weight: 800;
  color: ${plus.primary};
  background: ${plus.gradient};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export default PageTitle;
